import React from "react";
import ReactDOM from "react-dom";
import { Route, Switch, HashRouter } from "react-router-dom";
import { NavBar } from "molecules";
import { Footer } from "organisms";
import { TEXTS } from "./constants";

// pages for this product
import { Terms, Legal, Home } from "views";

ReactDOM.render(
  <div>
    <HashRouter basename={process.env.PUBLIC_URL}>
      <NavBar
        onIconClicked={() => {
          window.location.href = TEXTS.WEB_URL;
        }}
      />
      <Switch>
        <Route exact path="/home" component={Home} />
        <Route exact path="/terms" component={Terms} />
        <Route exact path="/legal" component={Legal} />
        <Route path="*" component={Home} />
      </Switch>

      <Footer/>
    </HashRouter>
  </div>,

  document.getElementById("root")
);
